export interface ManageReservationParams {
  unitId: string;
  reservationId: string;
  manageToken: string;
  adminToken: string;
  modificationId: string;
  action: 'approve' | 'reject' | null;
}

export const parseManageReservationParams = (
  search: string
): ManageReservationParams => {
  const searchParams = new URLSearchParams(search);
  const unitId = searchParams.get('unitId') || '';
  const reservationId =
    searchParams.get('reservationId') || searchParams.get('bookingId') || '';
  const manageToken =
    searchParams.get('token') || searchParams.get('manageToken') || '';
  const adminToken =
    searchParams.get('adminToken') || searchParams.get('adminActionToken') || '';
  const modificationId = searchParams.get('modificationId') || '';
  const actionParam = searchParams.get('action');
  const action = actionParam === 'approve' || actionParam === 'reject' ? actionParam : null;

  return {
    unitId,
    reservationId,
    manageToken,
    adminToken,
    modificationId,
    action,
  };
};
